export class CustomError extends Error {
  name: string
  constructor({ name, message }: { name: string; message: string }) {
    super(message)
    this.name = name
  }
}
